class DealStatuses {
  constructor(deal, authStore) {
    this.deal = deal
    this.authStore = authStore

    this.dealStatuses = this.calculateDealStatuses()
  }

  calculateDealStatuses = () => {
    this.registrationStatuses = this.calculateRegistrationStatuses()
    this.tcsStatuses = this.calculateTCSStatuses()

    const showVerifySaleButton = this.deal.flags.includes('sale_made') && this.deal.flags.includes('awaiting_sale_verification') && this.authStore.anyRoles(['verify_sales', 'qc']) && !this.deal.flags.includes('completed')
    const showSetupCoachingPortal = this.deal.flags.includes('sale_made')

    const showVerifyUpgradeButton = this.deal.flags.includes('sale_made') && this.deal.flags.includes('awaiting_upgrade_verification') && this.authStore.anyRoles(['verify_sales', 'qc']) && !this.deal.flags.includes('completed')
    const showUpgradeButtons = this.deal.flags.includes('sale_made') && this.deal.flags.includes('sale_verified') && !this.deal.flags.includes('upgrade_made') && !this.deal.flags.includes('completed')
    const showReviewSale = this.authStore.anyRoles(['review_sales', 'qc']) && !this.deal.flags.includes('awaiting_sale_verification') && !this.deal.flags.includes('awaiting_upgrade_verification') &&
      (this.deal.flags.includes('sale_made') || this.deal.flags.includes('upgrade_made')) && !this.deal.flags.includes('completed')

    const showSaleButtons = (!this.deal.flags.includes('sale_made') && !this.deal.flags.includes('no_sale') && !this.deal.flags.includes('completed')) ||
      (this.authStore.anyRoles(['qc']) && !this.deal.flags.includes('completed') && !showUpgradeButtons && !showVerifyUpgradeButton && !showVerifySaleButton && !showReviewSale)

    const showNoSaleButtons = !this.deal.flags.includes('no_sale') && !this.deal.flags.includes('sale_made') && !this.deal.flags.includes('upgrade_made') && !this.deal.flags.includes('completed')
    const showCancelledButtons = this.authStore.hasRole('admin') && this.deal.flags.includes('sale_made') && !this.deal.flags.includes('tcs_cancelled')

    const showDeadDealButtons = !this.deal.flags.includes('awaiting_final_review') && !this.deal.flags.includes('completed')

    const registrationCompleted = this.registrationStatuses.statuses.registrationCompleted || this.registrationStatuses.statuses.noRegistration
    const tcsCompleted = this.tcsStatuses.statuses.tcsCompleted || this.tcsStatuses.statuses.noTCS
    const dealButtonsEnabled = registrationCompleted && tcsCompleted

    const showSetupPortal = !this.deal.flags.includes('portal_setup') && this.authStore.hasRole('setup_portal')

    const ShowPutOnHold = this.deal.flags.includes('tcs_presented')
    const ShowTakeOffHold = this.deal.flags.includes('on_hold')

    const statuses = {
      buttons: {
        putOnHold: ShowPutOnHold,
        takeOffHold: dealButtonsEnabled && ShowTakeOffHold,
        saleMade: dealButtonsEnabled && showSaleButtons,
        upgradeMade: dealButtonsEnabled && showUpgradeButtons,
        noSale: dealButtonsEnabled && showNoSaleButtons,
        cancelled: dealButtonsEnabled && showCancelledButtons,
        deadDeal: showDeadDealButtons,
        verifySale: dealButtonsEnabled && showVerifySaleButton,
        setupCoachingPortal: dealButtonsEnabled && showSetupCoachingPortal,
        verifyUpgrade: dealButtonsEnabled && showVerifyUpgradeButton,
        reviewSale: dealButtonsEnabled && showReviewSale,
        showSetupPortal: dealButtonsEnabled && showSetupPortal
      },
      statuses: {
        dealCompleted: this.deal.flags.includes('completed'),
        registrationCompleted: registrationCompleted,
        tcsCompleted: tcsCompleted
      }
    }

    statuses.buttons.noButtonsToShow = Object.keys(statuses).every((k) => !statuses[k])
    return statuses
  }

  calculateRegistrationStatuses = () => {
    const confirmDone = this.deal.flags.includes('seminar_attendee_confirmed') || this.deal.flags.includes('seminar_attendee_not_confirmed')
    const attendedDone = this.deal.flags.includes('seminar_attended') || this.deal.flags.includes('seminar_not_attended')
    const registrationCompleted = this.deal.flags.includes('seminar_cancelled') || attendedDone

    const statuses = {
      buttons: {
        markAttendeeConfirmed: !registrationCompleted && !confirmDone,
        markAttendeeNotConfirmed: !registrationCompleted && !confirmDone,
        markSeminarAttended: !registrationCompleted && confirmDone && !attendedDone,
        markSeminarNotAttended: !registrationCompleted && confirmDone && !attendedDone,
        markRegistrationCancelled: !registrationCompleted,
        reschedule: !registrationCompleted && !attendedDone,
      },
      statuses: {
        registrationCompleted: registrationCompleted,
        dealCompleted: this.deal.flags.includes('completed'),
        noRegistration: !this.deal.registration_seminar_id
      }
    }
    statuses.buttons.noButtonsToShow = Object.keys(statuses).every((k) => !statuses[k])
    return statuses
  }

  calculateTCSStatuses = () => {
    const presented = this.deal.flags.includes('tcs_presented')
    const confirmDone = this.deal.flags.includes('tcs_attendee_confirmed') || this.deal.flags.includes('tcs_attendee_not_confirmed')
    const tcsCompleted = presented || this.deal.flags.includes("tcs_not_presented");
    const hasTCS = this.deal.tcs_at !== null
    const dealDeal = this.deal.flags.includes('dead_deal')

    const statuses = {
      buttons: {
        tcsMarkAttendeeConfirmed: !presented && !confirmDone && hasTCS,
        tcsPresented: confirmDone && hasTCS && !tcsCompleted,
        tcsNotPresented: confirmDone && hasTCS && !tcsCompleted,
        tcsReschedule: !tcsCompleted && !dealDeal && hasTCS,
        bookTCS: !this.deal.flags.includes('no_sale') && !this.deal.flags.includes('sale_made') && !this.deal.flags.includes('completed') && !hasTCS,
        undoAttendeeConfirmation: !dealDeal && !tcsCompleted && confirmDone,
        undoDeadDeal: dealDeal,
        undoPresented: !dealDeal && tcsCompleted,
        undoNoSale: this.deal.flags.includes('no_sale')
      },
      statuses: {
        tcsCompleted: tcsCompleted,
        dealCompleted: this.deal.flags.includes('completed'),
        noTCS: !hasTCS,
        tcsPresented: presented
      }
    }
    statuses.buttons.noButtonsToShow = Object.keys(statuses).every((k) => !statuses[k])
    return statuses
  }

}

export default DealStatuses
